module.exports = __webpack_public_path__ + "static/stretchconf2018-5b528da29f2fbff15793a79fef2b0e17.jpg";